/*
 * @Author: heshouzhi heshouzhi@millionlab.cn
 * @Date: 2024-05-10 16:28:03
 * @LastEditors: heshouzhi heshouzhi@millionlab.cn
 * @LastEditTime: 2024-05-11 14:39:25
 * @FilePath: /web-crm/src/pages/gift/gift_data/models/giftData.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as giftData from '../services/giftData';

export default {
  namespace: 'giftData',
  state: {},
  effects: {
    //运营规则列表
    *queryEventPage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(giftData.queryEventPage, values);
      yield put({
        type: 'save',
        payload: {
          activityList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *activityDelete({ payload: { values }, callback }, { call }) {
      const response = yield call(giftData.activityDelete, values);
      callback(response);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
